import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';

import { ChatTokenResponse } from './chat-token.models';

@Injectable({ providedIn: 'root' })
export class ChatTokenApiService {
  #gateway = inject(ApiGateway);

  getToken() {
    return this.#gateway.get<ChatTokenResponse>('chat/token', {
      headers: { ignoreMetaMessage: true },
    });
  }
}
